/* RaízClean: galería y carruseles del clon (clx-pdp-slider / clx-pdp-gallery) */
(function () {
  'use strict';
  if (window.__clxGaleria) return;
  window.__clxGaleria = true;

  function slides(track) {
    return Array.prototype.filter.call(track.children, function (el) { return el.offsetParent !== null; });
  }

  function indiceActual(track) {
    var s = slides(track), x = track.scrollLeft, best = 0, dist = Infinity;
    s.forEach(function (el, i) {
      var d = Math.abs(el.offsetLeft - track.offsetLeft - x);
      if (d < dist) { dist = d; best = i; }
    });
    return best;
  }

  function irA(track, i) {
    var s = slides(track);
    if (!s.length) return;
    i = Math.max(0, Math.min(i, s.length - 1));
    var img = s[i].querySelector('img[loading="lazy"]');
    if (img) img.loading = 'eager';
    track.scrollTo({ left: s[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    if (track.__clxUpd) setTimeout(track.__clxUpd, 450);
  }

  function montarSlider(root) {
    if (root.__clxOk) return;
    var track = root.querySelector('[data-slider-track]');
    if (!track) return;
    root.__clxOk = true;
    var prev = root.querySelector('[data-slider-prev]');
    var next = root.querySelector('[data-slider-next]');
    var dotsBox = root.querySelector('[data-slider-dots]');
    var dots = [];

    if (dotsBox && !dotsBox.children.length) {
      slides(track).forEach(function (el, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdp-dot';
        b.setAttribute('aria-label', 'Ir a ' + (i + 1));
        b.style.cssText = 'width:8px;height:8px;margin:8px 4px;padding:0;border:0;border-radius:50%;background:#000;opacity:.25;cursor:pointer';
        b.addEventListener('click', function () { irA(track, i); });
        dotsBox.appendChild(b);
        dots.push(b);
      });
    }

    function actualizar() {
      var i = indiceActual(track), n = slides(track).length;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      dots.forEach(function (d, k) { d.style.opacity = k === i ? '1' : '.25'; });
      slides(track).forEach(function (el, k) {
        if (k === i) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', 'true');
        if (Math.abs(k - i) <= 1) {
          var img = el.querySelector('img[loading="lazy"]');
          if (img) img.loading = 'eager';
        }
      });
      root.dispatchEvent(new CustomEvent('clx:slide', { detail: { index: i, total: n } }));
    }

    track.__clxUpd = actualizar;
    if (prev) prev.addEventListener('click', function () { irA(track, indiceActual(track) - 1); });
    if (next) next.addEventListener('click', function () { irA(track, indiceActual(track) + 1); });
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(actualizar, 60); }, { passive: true });
    window.addEventListener('resize', actualizar);
    actualizar();
  }

  function montarGaleria(g) {
    if (g.__clxOk) return;
    g.__clxOk = true;
    var main = g.querySelector('[data-gallery-main]');
    var track = main && main.querySelector('[data-slider-track]');
    var thumbsBox = g.querySelector('[data-gallery-thumbs]');
    if (!track || !thumbsBox) return;
    var thumbs = Array.prototype.slice.call(thumbsBox.querySelectorAll('[data-index]'));

    /* Fotos ligeras (~10 KB): se cargan todas al terminar la página para que deslizar no muestre huecos */
    function cargarTodas() {
      track.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }
    if (document.readyState === 'complete') cargarTodas(); else window.addEventListener('load', cargarTodas);

    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        thumbs.forEach(function (o) { o.removeAttribute('aria-current'); });
        b.setAttribute('aria-current', 'true');
        irA(track, parseInt(b.getAttribute('data-index'), 10) || 0);
      });
    });

    main.addEventListener('clx:slide', function (e) {
      thumbs.forEach(function (b, k) {
        if (k === e.detail.index) {
          b.setAttribute('aria-current', 'true');
          var l = b.offsetLeft - thumbsBox.offsetLeft;
          if (l < thumbsBox.scrollLeft || l + b.offsetWidth > thumbsBox.scrollLeft + thumbsBox.clientWidth) {
            thumbsBox.scrollTo({ left: l - 10, behavior: 'smooth' });
          }
        } else {
          b.removeAttribute('aria-current');
        }
      });
    });
  }

  /* Vídeos del referente: no son nuestros, no se cargan. Se oculta el hueco vacío. */
  function ocultarVideosAjenos() {
    document.querySelectorAll('.clx-root clx-pdp-lazy-video').forEach(function (v) {
      var media = v.closest('.pdp-media-text__media') || v;
      media.style.display = 'none';
    });
  }

  function iniciar() {
    document.querySelectorAll('.clx-root clx-pdp-gallery').forEach(montarGaleria);
    document.querySelectorAll('.clx-root clx-pdp-slider').forEach(montarSlider);
    ocultarVideosAjenos();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
